const snackbarPlugin = {
  install: (Vue, { store }) => {
    if (!store) {
      throw new Error('Please provide vuex store.');
    }

    Vue.prototype.$snackbar = {
      showMessage: function ({
        content = '',
        color = '',
        timeout = -1
      }) {
        store.commit(
          'snackbar/showMessage',
          { content, color, timeout },
          { root: true }
        );
      }
    };
  },
};
export default snackbarPlugin;